/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeletePartitionPartitionsPartitionIdDeleteRequest = {
  partitionId: string;
  /**
   * If true, performs partition deletion asynchronously.
   */
  async?: boolean | null | undefined;
};

/** @internal */
export const DeletePartitionPartitionsPartitionIdDeleteRequest$inboundSchema:
  z.ZodType<
    DeletePartitionPartitionsPartitionIdDeleteRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    partition_id: z.string(),
    async: z.nullable(z.boolean()).optional(),
  }).transform((v) => {
    return remap$(v, {
      "partition_id": "partitionId",
    });
  });
/** @internal */
export type DeletePartitionPartitionsPartitionIdDeleteRequest$Outbound = {
  partition_id: string;
  async?: boolean | null | undefined;
};

/** @internal */
export const DeletePartitionPartitionsPartitionIdDeleteRequest$outboundSchema:
  z.ZodType<
    DeletePartitionPartitionsPartitionIdDeleteRequest$Outbound,
    z.ZodTypeDef,
    DeletePartitionPartitionsPartitionIdDeleteRequest
  > = z.object({
    partitionId: z.string(),
    async: z.nullable(z.boolean()).optional(),
  }).transform((v) => {
    return remap$(v, {
      partitionId: "partition_id",
    });
  });

export function deletePartitionPartitionsPartitionIdDeleteRequestToJSON(
  deletePartitionPartitionsPartitionIdDeleteRequest:
    DeletePartitionPartitionsPartitionIdDeleteRequest,
): string {
  return JSON.stringify(
    DeletePartitionPartitionsPartitionIdDeleteRequest$outboundSchema.parse(
      deletePartitionPartitionsPartitionIdDeleteRequest,
    ),
  );
}
export function deletePartitionPartitionsPartitionIdDeleteRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  DeletePartitionPartitionsPartitionIdDeleteRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      DeletePartitionPartitionsPartitionIdDeleteRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'DeletePartitionPartitionsPartitionIdDeleteRequest' from JSON`,
  );
}
